import { render, staticRenderFns } from "./ProxySetting.vue?vue&type=template&id=723d54f3&scoped=true&"
import script from "./ProxySetting.vue?vue&type=script&lang=ts&"
export * from "./ProxySetting.vue?vue&type=script&lang=ts&"
import style0 from "./ProxySetting.vue?vue&type=style&index=0&id=723d54f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723d54f3",
  null
  
)

export default component.exports